export const FREE_MEMBERSHIP = 'freeMembership';
export const STARTUP_MEMBERSHIP = 'startupMembership';
export const PROFESSIONAL_MEMBERSHIP = 'professionalMembership';

export const MEMBERSHIP_TYPES = [
  FREE_MEMBERSHIP,
  STARTUP_MEMBERSHIP,
  PROFESSIONAL_MEMBERSHIP,
];

export const MEMBERSHIP_ORDER = {
  [FREE_MEMBERSHIP]: 0,
  [STARTUP_MEMBERSHIP]: 1,
  [PROFESSIONAL_MEMBERSHIP]: 2,
};

export const MEMBERSHIP_GROUPS = {
  all: [...MEMBERSHIP_TYPES],
  paid: [STARTUP_MEMBERSHIP, PROFESSIONAL_MEMBERSHIP],
  professionalOnly: [PROFESSIONAL_MEMBERSHIP],
};

export const MEMBERSHIP_ROUTE_ACCESS = {
  app: [...MEMBERSHIP_GROUPS.all],
  account: [...MEMBERSHIP_GROUPS.all],
  findInvestors: [...MEMBERSHIP_GROUPS.all],
  crm: [...MEMBERSHIP_GROUPS.paid],
  deals: [...MEMBERSHIP_GROUPS.professionalOnly],
  statistics: [...MEMBERSHIP_GROUPS.professionalOnly],
  aiFunding: [...MEMBERSHIP_GROUPS.professionalOnly],
};

export const MEMBERSHIP_ACCESS_CONFIG = {
  [FREE_MEMBERSHIP]: {
    features: {
      boards: false,
      crm: false,
      addInvestor: false,
      investorSensitiveInfo: false,
      investmentInfoFilter: false,
      deals: false,
      statistics: false,
      aiFunding: false,
      dataExport: false,
      coInvestDetails: false,
      dealRecipientCompany: false,
    },
    dealCard: {
      recipientCompanyAccessMode: 'professionalOnly',
      investorVisibleDeals: {
        under10: 0,
        under100: 1,
        under401: 4,
        default: 5,
      },
    },
  },
  [STARTUP_MEMBERSHIP]: {
    features: {
      boards: true,
      crm: true,
      addInvestor: true,
      investorSensitiveInfo: true,
      investmentInfoFilter: true,
      deals: false,
      statistics: false,
      aiFunding: false,
      dataExport: false,
      coInvestDetails: true,
      dealRecipientCompany: false,
    },
    dealCard: {
      recipientCompanyAccessMode: 'professionalOnly',
      investorVisibleDeals: {
        under10: 0,
        under100: 1,
        under401: 4,
        default: 5,
      },
    },
  },
  [PROFESSIONAL_MEMBERSHIP]: {
    features: {
      boards: true,
      crm: true,
      addInvestor: true,
      investorSensitiveInfo: true,
      investmentInfoFilter: true,
      deals: true,
      statistics: true,
      aiFunding: true,
      dataExport: true,
      coInvestDetails: true,
      dealRecipientCompany: true,
    },
    dealCard: {
      recipientCompanyAccessMode: 'full',
      investorVisibleDeals: 'all',
    },
  },
};
